module.exports = __webpack_public_path__ + "img/thumbnail_noimg.ccdfa292.png";